import { AuthService } from './auth.service';
import { User, Role } from './user.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BaseEntityService } from "./base-entity.service";
import { Itinerary, Status } from "./itineray.model";
import { AngularFirestore } from "@angular/fire/firestore";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class ItineraryService extends BaseEntityService<Itinerary> {
  constructor(db: AngularFirestore) {
    super(db, Itinerary, "/", "itineraries");
  }

  listForAssignee(assignee: User, archived: boolean): Observable<Itinerary[]> {
    this.log("listForAssignee", assignee.id);
    return this.list(ref => ref.where('assignee', '==', this.db.doc("/users/" + assignee.id).ref).where("archived", "==", archived));
  }

  listForCustomer(customer: User): Observable<Itinerary[]> {
    this.log("listForCustomer", customer.id);
    return this.list(ref => ref.where('customer', '==', this.db.doc("/users/" + customer.id).ref));
  }

  isItineraryReadOnlyForCurrentUser(itinerary: Itinerary) {
    return itinerary.status === Status.DONE || itinerary.status === Status.IN_REVIEW || itinerary.status === Status.PROCESSING;
  }
}
